import cn from 'classnames';
import { Link } from '@/Framework/Router/Next/Link';
import links, { ILinkConfig } from './linksConfig';

import styles from '../header.scss';

interface ILinksProps {
  linksConfig?: ILinkConfig[],
  wrapperClassName?: string,
  callbackItemClick?: () => void,
}

const Links = ({
  linksConfig = links,
  wrapperClassName,
  callbackItemClick,
}: ILinksProps) => (
  <div className={ cn(styles.linksWrapper, wrapperClassName) }>
    {
      linksConfig.map(({ url, dataTest, IconLink, label }) => (
        <Link
          key={ dataTest }
          onClick={ callbackItemClick }
          className={ styles.solutionsButton }
          to={ url }
          dataTest={ dataTest }
        >
          <div className={ styles.iconContainer }>
            { IconLink && <IconLink /> }
            <span>{ label }</span>
          </div>
        </Link>
      ))
    }
  </div>
);

export default Links;
